<template>
  <div>
    <p :class="['form-item-title', size]">{{ label }}</p>
    <slot />
  </div>
</template>

<script>
export default {
  props: {
    label: {
      type: String,
      default: ''
    },
    size: {
      type: String,
      default: 'small'
    }
  }
}
</script>

<style lang="scss" scoped>
.form-item-title {
  color: #545454;
  letter-spacing: 0.53px;
  font-weight: bold;
}

.small {
  font-size: 12px;
  margin: {
    bottom: 4px;
    left: 8px;
  }
}

.normal {
  font-size: 14px;
  margin: {
    bottom: 12px;
  }
}
</style>
